import type { IconType } from "react-icons";
import { icons, type IconKey } from "@core/assets";

type IconProps = {
  name: IconKey | IconType;
  className?: string;
  strokeWidth?: number;
  onClick?: () => void;
  "aria-label"?: string;
};

const Icon = ({
  name,
  className,
  strokeWidth,
  onClick,
  "aria-label": ariaLabel,
}: IconProps) => {
  const IconComponent =
    typeof name === "string" ? icons[name as IconKey] : (name as IconType);

  if (!IconComponent) return null;

  return (
    <IconComponent
      className={className}
      strokeWidth={strokeWidth}
      onClick={onClick}
      aria-label={ariaLabel}
    />
  );
};

Icon.displayName = "Icon";

export { Icon };
export default Icon;
